import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  CancelChamadoParams,
  CancelChamadoResponse,
  CreateChamadoParams,
  CreateChamadoResponse,
  EndChamadoParams,
  EndChamadoResponse,
  FindChamadoByIdParams,
  FindChamadoByIdResponse,
  SearchChamadosParams,
  SearchChamadosResponse,
  TechAssignChamadoParams,
  TechAssignChamadoResponse,
} from '../domain/chamado'

const ROOT_URL = '/entity/calls'

export const ChamadoService = {
  search: async (params: SearchChamadosParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchChamadosResponse>(url)
  },

  findById: async ({ callId }: FindChamadoByIdParams) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.get<FindChamadoByIdResponse>(url)
  },

  create: async (params: CreateChamadoParams) => {
    const formData = new FormData()
    formData.append('assetId', params.assetId)
    formData.append('description', params.description)
    formData.append('requesterName', params.requesterName)
    formData.append('requesterPhone', params.requesterPhone)
    formData.append('requesterMail', params.requesterMail)
    params.files.map((ea) => formData.append('files', ea.file))

    const url = ROOT_URL
    return await WitaConnector.post<CreateChamadoResponse>(url, formData)
  },

  techAssign: async ({ id, ...params }: TechAssignChamadoParams) => {
    const url = ROOT_URL + `/${id}/tech-assign`
    return await WitaConnector.put<TechAssignChamadoResponse>(url, params)
  },

  end: async ({ id, ...params }: EndChamadoParams) => {
    const url = ROOT_URL + `/${id}/end`
    return await WitaConnector.put<EndChamadoResponse>(url, params)
  },

  cancel: async ({ id, ...params }: CancelChamadoParams) => {
    const url = ROOT_URL + `/${id}/cancel`
    return await WitaConnector.put<CancelChamadoResponse>(url, params)
  },
}
